<nb-card class="w-100">
    <nb-card-body>
        <file-upload formControlName="files" [multiple]="false"
            [accept]="'.csv, .xls, .xlsx, text/csv, application/csv,text/comma-separated-values, application/csv, application/excel,application/vnd.msexcel, text/anytext, application/vnd. ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
            v-else>
        </file-upload>
    </nb-card-body>
</nb-card>